import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Router, RouterLink, RouterOutlet } from '@angular/router'

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

import { hasTrygroupManagementRole } from '../../guards/trygroup-dashboard-access'
import { UserStore } from '../../stores/user.store'

@UntilDestroy()
@Component({
  selector: 'app-trygroup-dashboard-shell',
  standalone: true,
  imports: [RouterLink, RouterOutlet],
  template: `
    <section class="dashboard-shell">
      <header
        class="dashboard-topbar"
        aria-label="トライグループダッシュボード"
      >
        <span class="dashboard-title">Trygroup Dashboard</span>
        @if (showManagerNav) {
          <nav>
            <a
              routerLink="/trygroup-dashboard/priority-list"
              [class.active]="router.url.includes('/priority-list')"
            >
              育成優先リスト
            </a>
            <a
              routerLink="/trygroup-dashboard/settings"
              [class.active]="router.url.includes('/settings')"
            >
              設定
            </a>
          </nav>
        }
      </header>

      <main class="dashboard-main">
        <router-outlet></router-outlet>
      </main>
    </section>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .dashboard-shell {
        max-width: 1480px;
        min-height: calc(100vh - 80px);
        padding: 24px;
        margin: 0 auto;
        background: #f8fafc;
      }

      .dashboard-topbar {
        display: flex;
        gap: 24px;
        align-items: center;
        padding: 0 16px;
        margin-bottom: 20px;
        background: #ffffff;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
      }

      .dashboard-title {
        flex: 0 0 auto;
        padding: 14px 0;
        color: #0f172a;
        font-size: 13px;
        font-weight: 800;
      }

      nav {
        display: flex;
        gap: 4px;
      }

      a {
        display: flex;
        align-items: center;
        min-height: 40px;
        padding: 0 12px;
        color: #475569;
        font-size: 14px;
        font-weight: 700;
        text-decoration: none;
        border-radius: 6px;
      }

      a:hover {
        color: #0f172a;
        background: #f1f5f9;
      }

      a.active {
        color: #1d4ed8;
        background: #eff6ff;
      }

      .dashboard-main {
        min-width: 0;
      }

      @media (width < 700px) {
        .dashboard-shell {
          padding: 16px;
        }

        .dashboard-topbar {
          flex-wrap: wrap;
          gap: 8px;
          padding: 12px 16px;
        }
      }
    `,
  ],
})
export class TrygroupDashboardShellComponent implements OnInit {
  showManagerNav = false

  constructor(
    public readonly router: Router,
    private readonly userStore: UserStore,
  ) {}

  ngOnInit(): void {
    this.userStore
      .getOneSelf({ useCache: true })
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.showManagerNav =
          user.roles.some((role) => role.code === 'SUPER_ADMIN') ||
          hasTrygroupManagementRole(user)
      })
  }
}
